
import { Vue, Component } from 'vue-property-decorator'
import Tenant from '@/types/tenant'
import Column from '@/types/column'
import TenantShowDetailsTab from '@/views/tenant/tabs/show/TenantShowDetailsTab.vue'
import TenantShowContactsTab from '@/views/tenant/tabs/show/TenantShowContactsTab.vue'
import TenantDocumentsTab from '@/views/tenant/tabs/TenantDocumentsTab.vue'
import CustomerDocumentsTab from '@/views/customer/tabs/CustomerDocumentsTab.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { CustomerDocumentsTab, TenantDocumentsTab, TenantShowContactsTab, TenantShowDetailsTab }
})

export default class TenantShow extends Vue {
  settings = {
    routeNames: { list: 'tenants', show: 'tenantShow', edit: 'tenantEdit' },
    routeParamKey: 'tenantId',
    functionNames: { setCurrent: 'setCurrentTenant', clearCurrent: 'clearCurrentTenant', save: 'saveTenant' },
    getterNames: { current: 'currentTenant', loading: 'loadingTenant' }
  }

  currentTab:string = ls.get('tenantShowActiveTab') || 'details'

  buildingColumns:Column[] = [
    {
      title: 'Project',
      key: 'project',
      scopedSlots: { customRender: 'project' }
    },
    {
      title: 'Bouwnummer',
      key: 'number',
      scopedSlots: { customRender: 'number' }
    },
    {
      title: 'Adres',
      key: 'address',
      scopedSlots: { customRender: 'address' }
    },
    {
      title: 'Status',
      key: 'state',
      dataIndex: 'state_label',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Actie\'s',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  showDocumentsTab = true

  toggleDocumentsTab () : void {
    this.showDocumentsTab = !this.showDocumentsTab
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  setActiveTab (tab:string) : void {
    ls.set('tenantShowActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  onRowClick (rowData:{id:number}) : { on: { click: () => void }} {
    return {
      on: {
        click: () => {
          const keyboard = window.event as KeyboardEvent
          if (can('buildings.edit')) {
            const route = this.$router.resolve({ name: 'buildingEdit', params: { buildingId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          } else if (can('buildings.view')) {
            const route = this.$router.resolve({ name: 'buildingShow', params: { buildingId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          }
        }
      }
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Tenant {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
